import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import { formatPercent } from "../../helpers/formatBytes";

export default function MasterDonutChart({ percent, color = "#3b82f6", trackColor, height = 160 }) {
	const used = Math.min(100, Math.max(0, Number(percent) || 0));
	const data = [
		{ name: "used", value: used || 0.01, color },
		{ name: "free", value: Math.max(0.01, 100 - used), color: trackColor || "#e4e4e7" },
	];

	return (
		<div className="relative mx-auto w-full" style={{ height }}>
			<ResponsiveContainer width="100%" height="100%">
				<PieChart>
					<Pie
						data={data}
						dataKey="value"
						innerRadius="62%"
						outerRadius="88%"
						paddingAngle={2}
						stroke="none"
					>
						{data.map((entry, i) => (
							<Cell key={i} fill={entry.color} />
						))}
					</Pie>
				</PieChart>
			</ResponsiveContainer>
			<div className="pointer-events-none absolute inset-0 flex items-center justify-center">
				<span className="text-xl font-semibold text-default-800 dark:text-default-100">
					{formatPercent(used)}
				</span>
			</div>
		</div>
	);
}
